module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-content"
  }, [_c('div', {
    attrs: {
      "id": "help2_wh"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "help_img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(7)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/bzzx.jpg",
      "alt": "帮助中心图标"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 7
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(7)
      }
    }
  }, [_vm._v("关于我们")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 8
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(8)
      }
    }
  }, [_vm._v("联系我们")])])])]), _vm._v(" "), _c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 9
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(9)
      }
    }
  }, [_vm._v("自营专区")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 10
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(10)
      }
    }
  }, [_vm._v("云优品服务站")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 11
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(11)
      }
    }
  }, [_vm._v("免费联盟商家")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 12
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(12)
      }
    }
  }, [_vm._v("菜篮子生活社区店")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 13
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(13)
      }
    }
  }, [_vm._v("入驻商家（非自营专区）")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 14
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(14)
      }
    }
  }, [_vm._v("邀请有奖")])])])]), _vm._v(" "), _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 15
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(15)
      }
    }
  }, [_vm._v("商城免费会员")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 16
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(16)
      }
    }
  }, [_vm._v("账户管理")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 17
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(17)
      }
    }
  }, [_vm._v("购物流程")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 18
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(18)
      }
    }
  }, [_vm._v("常见问题汇总")])])])]), _vm._v(" "), _c('ul', [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 19
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(19)
      }
    }
  }, [_vm._v("在线支付")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 20
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(20)
      }
    }
  }, [_vm._v("线下扫码")])])])]), _vm._v(" "), _c('ul', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 21
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(21)
      }
    }
  }, [_vm._v("自营商品配送方式")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 22
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(22)
      }
    }
  }, [_vm._v("第三方商品配送方式")])])])]), _vm._v(" "), _c('ul', [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 23
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(23)
      }
    }
  }, [_vm._v("自营商品售后")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(24)
      }
    }
  }, [_vm._v("第三方商家商品售后")])])])]), _vm._v(" "), _c('ul', [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 25
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(25)
      }
    }
  }, [_vm._v("服务条款")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 26
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(26)
      }
    }
  }, [_vm._v("隐私政策")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 27
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(27)
      }
    }
  }, [_vm._v("交易纠纷处理规则")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 28
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(28)
      }
    }
  }, [_vm._v(" 商家服务协议")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "help_spans"
  }, [_c('a', {
    class: {
      'active': _vm.articleid === 29
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cSideBar(29)
      }
    }
  }, [_vm._v(" 联盟商家入驻服务协议")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "help2_ul6"
  })]), _vm._v(" "), (!!_vm.articleContent) ? _c('div', {
    staticClass: "help-right",
    staticStyle: {
      "padding": "10px 20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.articleContent)
    }
  }) : _vm._e(), _vm._v(" "), (!!!_vm.articleContent) ? _c('div', {
    staticClass: "help-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 7),
      expression: "articleid === 7"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs01.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 8),
      expression: "articleid === 8"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs02.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 9),
      expression: "articleid === 9"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs03.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 10),
      expression: "articleid === 10"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs04.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 11),
      expression: "articleid === 11"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs05.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 12),
      expression: "articleid === 12"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs06.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 13),
      expression: "articleid === 13"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs07.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 14),
      expression: "articleid === 14"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs08.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 15),
      expression: "articleid === 15"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs09.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 16),
      expression: "articleid === 16"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs10.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 17),
      expression: "articleid === 17"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs11.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 18),
      expression: "articleid === 18"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs12.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 19),
      expression: "articleid === 19"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs13.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 20),
      expression: "articleid === 20"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs14.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 21),
      expression: "articleid === 21"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs15.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 22),
      expression: "articleid === 22"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs16.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 23),
      expression: "articleid === 23"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs17.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 24),
      expression: "articleid === 24"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs18.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 25),
      expression: "articleid === 25"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs19.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 26),
      expression: "articleid === 26"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs20.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/aboutUs/aboutUs21.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 27),
      expression: "articleid === 27"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/jiaoyijiufen.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 28),
      expression: "articleid === 28"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/shangjia1.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/shangjia2.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/shangjia3.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/shangjia4.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleid === 29),
      expression: "articleid === 29"
    }],
    staticClass: "client pt-2",
    staticStyle: {
      "margin-left": "47px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/lianmeng1.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/lianmeng2.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/lianmeng3.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "src": require("../../assets/images/xieyi/lianmeng4.jpg"),
      "alt": ""
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("关于网站")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help2_li2"
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "//static.kxymall.com/images/help_line_bj.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("版块介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help2_li2"
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "//static.kxymall.com/images/help_line_bj.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("新手指南")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help2_li2"
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "//static.kxymall.com/images/help_line_bj.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("支付方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help2_li2"
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "//static.kxymall.com/images/help_line_bj.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("配送方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help2_li2"
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "//static.kxymall.com/images/help_line_bj.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("售后服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help2_li2"
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "//static.kxymall.com/images/help_line_bj.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "help_li1"
  }, [_c('span', [_vm._v("购物条款")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-755214fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/help-center/help.vue
// module id = 1639
// module chunks = 1